import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_HOUSEKEEPER_URL}`
})

instance.defaults.paramsSerializer = (params) => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}

instance.interceptors.request.use(
  (reqConfig) => {
    if (Vue.prototype.$getCookie('comLoginToken')) {
      const xCorrelationId = Vue.prototype.$getGuid()
      reqConfig.headers = {
        authorization: Vue.prototype.$getCookie('JwtToken'),
        'x-requestid': Vue.prototype.$getGuid(),
        'X-Correlation-Id': xCorrelationId
      }
      Sentry.setTag('X-Correlation-Id', xCorrelationId)
      return reqConfig
    } else {
      Vue.prototype
        .$alert('請重新登入', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        })
        .then(() => {
          router.push({ name: 'LoginMain' })
        })
    }
  },
  (err) => {
    return Promise.reject(err)
  }
)

instance.interceptors.response.use(
  (res) => res,
  (err) => {
    console.log(err.response)
    if (err && err.response && err.response.status === 400) {
      return Promise.reject(err)
    } else if (err && err.response && err.response.status === 401) {
      Vue.prototype
        .$alert('登入過期或驗證失敗，請重新登入', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        })
        .then(() => {
          if (err.response.status === 401) router.push({ name: 'LoginMain' })
          else if (err.response.status === 403) Vue.prototype.$toMainPage()
        })
      return Promise.reject(err)
    } else if (err && err.response && err.response.status === 403) {
      Vue.prototype
        .$alert('未啟用電子看板服務', '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        })
        .then(() => {
          Vue.prototype.$toMainPage()
          return false
        })
    } else if (
      (err && err.response && err.response.status === 409) ||
      err.response.status === 404
    ) {
      Vue.prototype
        .$alert(err.response.data.ErrorMessage.Description, '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        })
        .then(() => {
          // eslint-disable-next-line eqeqeq
          if (err.response.status == 404) router.push({ name: 'LoginMain' })
        })
      return Promise.reject(err)
    } else {
      return Promise.reject(err)
    }
  }
)
// Swagger: https://housekeeper-web-dev.kingnetsmart.com.tw/swagger/index.html?urls.primaryName=Housekeeper%20Web%20API%20V1
const API_V1_BASEURL = '/api/v1/BulletinBoard'
const apiV1 = {
  layout: {
    list: () => `${API_V1_BASEURL}/`,
    get: ({ id }) => `${API_V1_BASEURL}/${id}`,
    new: () => `${API_V1_BASEURL}/`,
    update: ({ id }) => `${API_V1_BASEURL}/${id}`,
    delete: ({ id }) => `${API_V1_BASEURL}/${id}`
  },
  layoutCategory: {
    list: () => `${API_V1_BASEURL}/Default`
  },
  displayDevice: {
    get: ({ boardID }) => `${API_V1_BASEURL}/${boardID}/DisplayDevice`,
    delete: ({ id, displayDeviceID }) => `${API_V1_BASEURL}/${id}/${displayDeviceID}`
  },
  emergency: {
    get: () => `${API_V1_BASEURL}/EmergencyNotice`,
    getPublishing: () => `${API_V1_BASEURL}/EmergencyNotice/Publishing`,
    default: () => `${API_V1_BASEURL}/EmergencyNotice/Default`,
    new: () => `${API_V1_BASEURL}/EmergencyNotice`,　// abandoned at v2.37.1
    delete: () => `${API_V1_BASEURL}/EmergencyNotice`
  },
  settings: {
    get: () => `${API_V1_BASEURL}/DefaultSetting`,
    new: () => `${API_V1_BASEURL}/DefaultSetting`
  }
}

// Swagger: https://housekeeper-web-dev.kingnetsmart.com.tw/swagger/index.html?urls.primaryName=Housekeeper%20Web%20API%20V2
const API_V2_BASEURL = '/api/v2/BulletinBoard'
const apiV2 = {
  emergency: {
    new: () => `${API_V2_BASEURL}/EmergencyNotice/Publish`
  }
}

export const apiBulletin = {
  getLayoutList: (params, config) =>
    instance.get(apiV1.layout.list(), Object.assign({}, { params }), config),
  getLayout: (queryPath, config) => instance.get(apiV1.layout.get(queryPath), config),
  newLayout: (params, config) => instance.post(apiV1.layout.new(), params, config),
  updateLayout: (queryPath, params, config) =>
    instance.put(apiV1.layout.update(queryPath), params, config),
  deleteLayout: (queryPath, config) =>
    instance.delete(apiV1.layout.delete(queryPath), config),
  getDisplayDeviceList: (queryPath, config) =>
    instance.get(apiV1.displayDevice.get(queryPath), config),
  deleteDisplayDevice: (queryPath, config) =>
    instance.delete(apiV1.displayDevice.delete(queryPath), config),
  getLayoutCategoryList: (config) => instance.get(apiV1.layoutCategory.list(), config),
  getEmergencyBeingPublished: (config) => instance.get(apiV1.emergency.getPublishing(), config),
  getEmergencyDefault: (config) => instance.get(apiV1.emergency.default(), config),
  getDefaultAndCustomEmergency: (config) => instance.get(apiV1.emergency.get(), config),
  newEmergency: (params, config) =>
    instance.post(apiV2.emergency.new(), params, config),
  deleteEmergency: (queryPath, params, config) =>
    instance.put(apiV1.emergency.delete(), params, config),
  getSettings: (config) => instance.get(apiV1.settings.get(), config),
  newSettings: (params, config) =>
    instance.post(apiV1.settings.new(), params, config)
}
